import { atom } from "recoil";

export const routePointEditingState = atom({
  key: "routePointEditingState",
  default: false
});